import Box from '@mui/material/Box';
import { useLocation, useMatch } from 'react-router-dom';
import { useState } from 'react';
import { NavItem } from './components/NavItem';
import { LocalizedStrict } from '../../modules/localization/components/AppLocalized';
import { MERCHANT_ADMIN_ROUTE } from '../../constants/routes';
import { NewsBellNavItem } from './components/NewsBellNavItem';
import { EnviromentDropdown } from './components/EnviromentDropdown';
import { AvatarMenu } from './components/AvatarMenu';



export function MerchantNavAdmin() {
    const location = useLocation();
    const [activeLink, setActiveLink] = useState(location.pathname);

    const handleLinkClick = (path: string) => {
        setActiveLink(path);
    };




    return (
        <>
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                {/* <MobileNav>
                    <MobileNavItem activeLink={activeLink} handleLinkClick={handleLinkClick} route={MERCHANT_ROUTE}>
                        <LocalizedStrict id="nav-menu-merchant-menu-item-purchase-control">
                            <span>Purchase Control</span>
                        </LocalizedStrict>
                    </MobileNavItem>
                </MobileNav> */}
            </Box>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                <LocalizedStrict id='nav-menu-home'>
                    <NavItem handleLinkClick={handleLinkClick} route={MERCHANT_ADMIN_ROUTE}>
                        Home
                    </NavItem>
                </LocalizedStrict>



            </Box>

            <Box sx={{ flexGrow: 0 }}>
                <NewsBellNavItem />
                <EnviromentDropdown />
                <AvatarMenu />
            </Box >
        </>
    );
}

